import { render } from "./Return_employment.vue?vue&type=template&id=d7978db8"
import script from "./Return_employment.vue?vue&type=script&lang=js"
export * from "./Return_employment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__